/* eslint-disable tailwindcss/no-custom-classname */
const process = [
  {
    id: "1",
    title: "応募・書類選考",
    desc: "書類選考の結果は、応募後2週間以内にご連絡いたします",
    sub: "「レバテックダイレクト」さまよりご応募いただけます",
  },
  {
    id: "2",
    title: "適性検査・面接",
    desc: "1次選考（適性検査）<br class='tbpc'/>職種や状況に応じて個別にご連絡いたします",
  },
  {
    id: "3",
    title: "面接",
    desc: "面接の所要時間は45分程度、計2〜3回の面接を行います<br class='tbpc'/>結果は面接後2週間以内に連絡いたします",
  },
  {
    id: "4",
    title: "結果通知",
    desc: "Step1からStep4まで、<br class='tbpc'/>約1か月（最短2週間）程度の時間を要します",
  },
];

const CareerProcess = () => {
  return (
    <div id="process" className="--offset">
      <div className="relative mx-auto box-border max-w-7xl px-8 font-bold md:px-20 lg:px-20">
        <div className="space-y-4 md:space-y-8">
          <div className="space-y-2 md:space-y-1">
            <h2 className=" text-ter fluid-text-[11px,16px]">選考のプロセス</h2>
            <h3 className=" text-ter fluid-text-[18px,26px]">Process</h3>
          </div>
          <div className="flex flex-col gap-6">
            {process.map((step) => (
              <dl
                key={step.index}
                className="grid grid-cols-1 items-center gap-2 md:grid-cols-2 md:gap-10"
              >
                <dt className=" flex grid-cols-1 flex-col items-center justify-center gap-1 bg-bgc-dark py-4 md:gap-2 md:py-8">
                  <h6 className="font-bold text-txt-light fluid-text-[11px,14px]">
                    Step {step.id}
                  </h6>
                  <h3 className="font-bold text-txt-base fluid-text-[16px,22px]">
                    {step.title}
                  </h3>
                </dt>
                <dd className=" grid-cols-1 text-base text-txt-base">
                  {step.sub && (
                    <a
                      href="https://levtech-direct.jp/search?freeWord=%E3%83%88%E3%83%83%E3%82%AB%E3%82%B7%E3%82%B9%E3%83%86%E3%83%A0%E3%82%BA&annualIncome&skillJoin=or&exceptActionedJob"
                      className="text-link underline hover:text-hov hover:no-underline focus-visible:outline-2 focus-visible:outline-offset-2 active:text-hov/80"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {step.sub}
                    </a>
                  )}
                  <div
                    className="fluid-text-[14px,18px]"
                    dangerouslySetInnerHTML={{
                      __html: `${step.desc}`,
                    }}
                  />
                </dd>
              </dl>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CareerProcess;
